import { CalendarCheck, CarFront, Home as HomeIcon, UserRound } from "lucide-react";

export const MobileNav = ({ onNav, onBook }) => {
  const items = [
    { icon: HomeIcon, label: "Home", action: () => onNav("top"), testid: "mobilenav-home" },
    { icon: CarFront, label: "Flotta", action: () => onNav("flotta"), testid: "mobilenav-fleet" },
    { icon: CalendarCheck, label: "Prenota", action: onBook, testid: "mobilenav-book" },
    { icon: UserRound, label: "Profilo", action: null, href: "/account", testid: "mobilenav-account" },
  ];
  return (
    <nav
      className="fixed bottom-0 inset-x-0 z-40 md:hidden bg-white/95 backdrop-blur border-t border-gray-100 grid grid-cols-4 h-16 pb-[env(safe-area-inset-bottom)]"
      data-testid="mobile-bottom-nav"
    >
      {items.map(({ icon: Icon, label, action, href, testid }) =>
        href ? (
          <a key={label} href={href} className="flex flex-col items-center justify-center gap-0.5 text-[10px] font-semibold text-gray-500 active:text-fr-navy" data-testid={testid}>
            <Icon size={19} />
            {label}
          </a>
        ) : (
          <button key={label} onClick={action} className="flex flex-col items-center justify-center gap-0.5 text-[10px] font-semibold text-gray-500 active:text-fr-navy" data-testid={testid}>
            <Icon size={19} />
            {label}
          </button>
        )
      )}
    </nav>
  );
};

export default MobileNav;
